import { HECTO, KILO, MEGA } from 'constants/metricPrefixes'
import { UserDocumentTypeEnum } from 'modules/profile/types'
import { TServiceType } from 'modules/serviceType/types'
import { OrderCargoServiceType, OrderCreateCargoTotal } from 'schema'
import { PALLET_MAX_WIDTH_IN_CENTIMETER, PALLET_MIN_WIDTH_IN_CENTIMETER } from 'src/constants/pallet'

import { TOrderGuestCreateCargoForm } from '../../types/orderGuestCreateTypes'
import { ValidationValues } from './types'

export const VOLUME_LIMIT_SPECIAL_CARGO = 83 // м³
export const VOLUME_LIMIT = 80 // м³

export const WEIGHT_LIMIT_IN_TONNE = 20 // т
export const WEIGHT_TOTAL_LIMIT = 60 // кг
export const WEIGHT_SEPARATE_LIMIT_IN_TONNE = 0.7 // т
export const WEIGHT_SECIAL_SEPARATE_LIMIT_IN_TONNE = 1.3 // т
export const WEIGHT_LIMIT = WEIGHT_LIMIT_IN_TONNE * KILO // кг
export const WEIGHT_SEPARATE_LIMIT_IN_KG = WEIGHT_SEPARATE_LIMIT_IN_TONNE * KILO // кг
export const WEIGHT_SECIAL_SEPARATE_LIMIT_IN_KG = WEIGHT_SECIAL_SEPARATE_LIMIT_IN_TONNE * KILO // кг
export const WEIGHT_SEPARATE_LIMIT_IN_GRAM = WEIGHT_SEPARATE_LIMIT_IN_TONNE * MEGA // г
export const WEIGHT_SECIAL_SEPARATE_LIMIT_IN_GRAM = WEIGHT_SECIAL_SEPARATE_LIMIT_IN_TONNE * MEGA // г
export const LENGTH_LIMIT = 3.5 // м
export const LENGTH_LIMIT_IN_CENTIMETER = LENGTH_LIMIT * HECTO // см

export const MIN_LENGTH = 0.01 // м
export const MAX_LENGTH = 1.2 // м
export const MAX_LENGTH_CUSTOM_SPECIAL = 13 // м
export const MAX_LENGTH_TOTAL_SPECIAL_CARGO = 13 // м
export const MAX_LENGTH_TOTAL = 1.2 // м
export const MIN_LENGTH_IN_CENTIMETER = MIN_LENGTH * HECTO // см
export const MAX_LENGTH_IN_CENTIMETER = MAX_LENGTH * HECTO // см
export const MAX_LENGTH_CUSTOM_SPECIAL_IN_CENTIMETER = MAX_LENGTH_CUSTOM_SPECIAL * HECTO // см
export const MAX_LENGTH_TOTAL_IN_CENTIMETER = MAX_LENGTH_TOTAL * HECTO // см
export const MAX_LENGTH_GRADE = 999 // м
export const MAX_LENGTH_GRADE_IN_CENTIMETER = MAX_LENGTH_GRADE * HECTO // см

export const MIN_WIDTH = 0.01 // м
export const MAX_WIDTH = 0.8 // м
export const MAX_WIDTH_CUSTOM = 1.2 // м
export const MAX_WIDTH_CUSTOM_SPECIAL = 2.1 // м
export const MAX_WIDTH_TOTAL_SPECIAL_CARGO = 2.1 // м
export const MAX_WIDTH_TOTAL = 0.8 // м
export const MIN_WIDTH_IN_CENTIMETER = MIN_WIDTH * HECTO // см
export const MAX_WIDTH_IN_CENTIMETER = MAX_WIDTH * HECTO // см
export const MAX_WIDTH_CUSTOM_IN_CENTIMETER = MAX_WIDTH_CUSTOM * HECTO // см
export const MAX_WIDTH_CUSTOM_SPECIAL_IN_CENTIMETER = MAX_WIDTH_CUSTOM_SPECIAL * HECTO // см
export const MAX_WIDTH_GRADE = 99 // м
export const MAX_WIDTH_GRADE_IN_CENTIMETER = MAX_WIDTH_GRADE * HECTO // см

export const MIN_HEIGHT = 0.01 // м
export const MAX_HEIGHT = 1.4 // м
export const MAX_HEIGHT_PALLETE = 2.1 // м
export const MAX_HEIGHT_CUSTOM_SPECIAL = 2.1 // м
export const MAX_HEIGHT_TOTAL_SPECIAL_CARGO = 2.1 // м
export const MAX_HEIGHT_TOTAL = 1.4 // м
export const MIN_HEIGHT_IN_CENTIMETER = MIN_HEIGHT * HECTO // см
export const MAX_HEIGHT_IN_CENTIMETER = MAX_HEIGHT * HECTO // см
export const MAX_HEIGHT_PALLETE_IN_CENTIMETER = MAX_HEIGHT_PALLETE * HECTO // см
export const MAX_HEIGHT_SPECIAL_IN_CENTIMETER = MAX_HEIGHT_CUSTOM_SPECIAL * HECTO // см
export const MAX_HEIGHT_GRADE = 99 // м
export const MAX_HEIGHT_GRADE_IN_CENTIMETER = MAX_HEIGHT_GRADE * HECTO // см

export const MIN_WEIGHT = 0.001 // кг
export const MAX_WEIGHT_CUSTOM_SPECIAL = 1300 // кг
export const MAX_WEIGHT_PALLETE = 700 // кг
export const MAX_WEIGHT_CUSTOM = 60 // кг
export const MAX_WEIGHT_MIN = 0.001 // кг
export const MAX_WEIGHT_TOTAL = WEIGHT_LIMIT // кг
export const MAX_WEIGHT_GRADE = 99999 // кг

export const MIN_VOLUME = 0.01 // м³
export const MAX_VOLUME = VOLUME_LIMIT // м³
export const MAX_VOLUME_GRADE = 999 // м³

export const MIN_PRICE = 1 // ₽
export const MAX_PRICE = 10000000 // ₽
export const MAX_PRICE_GRADE = 999999999 // ₽

export const MIN_AMOUNT = 1 // шт
export const MAX_AMOUNT = 800 // шт
export const MAX_AMOUNT_GRADE = 9999 // шт

export const MAX_ABOUT = 1000

export const MAX_PALLETE_HEIGHT_IN_CENTIMETER = 180 // см

export const DEFAULT_CARGO_ITEM = {
  type: OrderCargoServiceType.Id.CUSTOM,
  amount: 1
} as unknown as TOrderGuestCreateCargoForm

export const DEFAULT_CARGO_TOTAL_ITEM = {
  type: OrderCreateCargoTotal.type.CUSTOM
}

export const OPTIONS_SERVICE_TYPE: TServiceType[] = [
  { id: OrderCargoServiceType.Id.CUSTOM, name: 'Гибкий' },
  { id: OrderCargoServiceType.Id.PALLET, name: 'Палета' }
]

export const validationTotal: ValidationValues['custom'] = {
  length: {
    min: MIN_LENGTH,
    max: MAX_LENGTH_TOTAL
  },
  width: {
    min: MIN_WIDTH,
    max: MAX_WIDTH_TOTAL
  },
  height: {
    min: MIN_HEIGHT,
    max: MAX_HEIGHT_TOTAL
  },
  weight: {
    min: MIN_WEIGHT,
    max: MAX_WEIGHT_TOTAL
  },
  volume: {
    min: MIN_VOLUME,
    max: MAX_VOLUME
  },
  price: {
    min: MIN_PRICE,
    max: MAX_PRICE
  },
  amount: {
    min: MIN_AMOUNT,
    max: MAX_AMOUNT
  },
  maxWeight: {
    min: MAX_WEIGHT_MIN,
    max: WEIGHT_TOTAL_LIMIT
  }
}

export const validationSpecialTotal: ValidationValues['custom'] = {
  ...validationTotal,
  volume: {
    min: MIN_VOLUME,
    max: VOLUME_LIMIT_SPECIAL_CARGO
  },
  length: {
    min: MIN_LENGTH,
    max: MAX_LENGTH_TOTAL_SPECIAL_CARGO
  },
  width: {
    min: MIN_WIDTH,
    max: MAX_WIDTH_TOTAL_SPECIAL_CARGO
  },
  height: {
    min: MIN_HEIGHT,
    max: MAX_HEIGHT_TOTAL_SPECIAL_CARGO
  },
  maxWeight: {
    min: MAX_WEIGHT_MIN,
    max: MAX_WEIGHT_TOTAL
  }
}

export const validationSeparateSpecial: ValidationValues = {
  custom: {
    length: {
      min: MIN_LENGTH_IN_CENTIMETER,
      max: MAX_LENGTH_CUSTOM_SPECIAL_IN_CENTIMETER
    },
    width: {
      min: MIN_WIDTH_IN_CENTIMETER,
      max: MAX_WIDTH_CUSTOM_SPECIAL_IN_CENTIMETER
    },
    height: {
      min: MIN_HEIGHT_IN_CENTIMETER,
      max: MAX_HEIGHT_SPECIAL_IN_CENTIMETER
    },
    weight: {
      min: MIN_WEIGHT,
      max: MAX_WEIGHT_CUSTOM_SPECIAL
    }
  },
  pallet: {
    // Длина 120 см задаётся декоратором формы
    length: {},
    width: {
      min: PALLET_MIN_WIDTH_IN_CENTIMETER,
      max: PALLET_MAX_WIDTH_IN_CENTIMETER
    },
    height: {
      min: MIN_HEIGHT_IN_CENTIMETER,
      max: MAX_HEIGHT_SPECIAL_IN_CENTIMETER
    },
    weight: {
      min: MIN_WEIGHT,
      max: MAX_WEIGHT_CUSTOM_SPECIAL
    }
  }
}

export const validationSeparate: ValidationValues = {
  custom: {
    length: {
      min: MIN_LENGTH_IN_CENTIMETER,
      max: MAX_LENGTH_IN_CENTIMETER
    },
    width: {
      min: MIN_WIDTH_IN_CENTIMETER,
      max: MAX_WIDTH_IN_CENTIMETER
    },
    height: {
      min: MIN_HEIGHT_IN_CENTIMETER,
      max: MAX_HEIGHT_IN_CENTIMETER
    },
    weight: {
      min: MIN_WEIGHT,
      max: MAX_WEIGHT_CUSTOM
    }
  },
  pallet: {
    // Длина 120 см и ширина 80 см задаются декоратором формы
    length: {},
    width: {},
    height: {
      min: MIN_HEIGHT_IN_CENTIMETER,
      max: MAX_HEIGHT_PALLETE_IN_CENTIMETER
    },
    weight: {
      min: MIN_WEIGHT,
      max: MAX_WEIGHT_PALLETE
    }
  }
}

export const MIN_CHARS_FOR_DOC_SERIES_BY_TYPE = {
  [UserDocumentTypeEnum.PassportRF]: 4,
  [UserDocumentTypeEnum.PassportInternational]: 2,
  [UserDocumentTypeEnum.DriverLicense]: 4
}

export const MIN_CHARS_FOR_DOC_NUMBER_BY_TYPE = {
  [UserDocumentTypeEnum.PassportRF]: 6,
  [UserDocumentTypeEnum.PassportInternational]: 7,
  [UserDocumentTypeEnum.DriverLicense]: 6
}
